import manager from 'app/module46/component-manager.js';

const stack = {};

manager.register('locale-selector', (component, elements, attributes, properties) => {
	
	const {
		buttons
	} = elements;

	for(const button of buttons) {
		
		if( ! stack[button.value]) {
			stack[button.value] = [];
		}

		stack[button.value].push(button);

		button.addEventListener('click', function(ev) {
			ev.preventDefault();
			for(const translated of document.querySelectorAll('[data-locale]')) {
				$(translated)[translated.dataset.locale == this.value ? 'fadeIn' : 'hide']();
			}
			for(const locale in stack) {
				const value = locale == this.value;
				for(const button of stack[locale]) {
					$(button).toggleClass('active', value);
				}
			}
		});
	}
});
